import React from 'react'

type Props = { label: string | React.ReactElement, bgColor: string, textColor?: string }
const ContentTag: React.FC<Props> = ({ label, bgColor, textColor = 'white' }) => {
  const bg = bgColor?.startsWith('#') ? `bg-[${bgColor}]` : `bg-${bgColor}`
  return (
    <div style={{ backgroundColor: bgColor }} className={`truncate max-w-[150px] sm:max-w-full px-3 py-1 rounded-sm text-2xs sm:text-xs font-normal whitespace-nowrap text-${textColor} ${bg}`}>
      {label}
    </div>
  )
}
export default ContentTag
